// extracted by mini-css-extract-plugin
export var searchHeader = "_9j-0";
export var searchHeaderDark = "_9j-1";